import axios from "axios";
import { useEffect, useState } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** Public hook: published job listings, ordered as configured in admin. */
export function useJobs() {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    axios
      .get(`${API}/jobs`)
      .then((r) => {
        if (!cancelled) setJobs(Array.isArray(r.data) ? r.data : []);
      })
      .catch((err) => {
        // Non-fatal - list is just empty in that case.
        console.warn("Failed to load jobs:", err?.message || err);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { jobs, loading };
}

/** Public hook: single job by slug. Returns `null` until loaded or 404. */
export function useJob(slug) {
  const [job, setJob] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    if (!slug) return;
    let cancelled = false;
    setLoading(true);
    setNotFound(false);
    axios
      .get(`${API}/jobs/${slug}`)
      .then((r) => {
        if (!cancelled) setJob(r.data);
      })
      .catch((err) => {
        if (cancelled) return;
        if (err?.response?.status === 404) setNotFound(true);
        else console.warn("Failed to load job:", err?.message || err);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [slug]);

  return { job, loading, notFound };
}
